// app 首页推荐卡片
export default {
  routes: [
    // 推荐卡片：https://act.zhuanzhuan.com/platform/zz-platform-pages/discovercard/bycate?needHideHead=1&title=%E5%93%81%E8%B4%A8%E7%94%9F%E6%B4%BB&cate=101_10532_2910,1100000095&tabs=%E6%89%AB%E5%9C%B0%E6%9C%BA%E5%99%A8%E4%BA%BA,%E6%8B%96%E5%9C%B0%E6%9C%BA%E5%99%A8%E4%BA%BA&active=0
    {
      path: '/(\\s*)discovercard(\\d*)/(\\s*)bycate(\\d*)',
      name: 'discovercardbycate',
      meta: {
        title: '推荐卡片'
      },
      component: () =>
        import(/* webpackChunkName: "discovercardbycate" */ '../views/discoverCard/bycate.vue')
    },
    {
      // 页面链接：https://act.zhuanzhuan.com/platform/zz-platform-pages/discovercard/byproduct?needHideHead=1&title=%E5%93%81%E8%B4%A8%E7%94%9F%E6%B4%BB&productId=1273872417676505854
      path: '/(\\s*)discovercard(\\d*)/(\\s*)byproduct(\\d*)',
      name: 'discovercardbyproduct',
      meta: {
        title: '推荐卡片'
      },
      component: () =>
        import(
          /* webpackChunkName: "discovercardbyproduct" */ '../views/discoverCard/byproduct.vue'
        )
    }
  ]
}
